import React, { useContext, useEffect } from 'react'
import './index.scss'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import ViewWork from '@Components/ViewWork'
import PublicWorkHeader from '@Components/ViewWork/Headers/PublicWorkHeader'
import { useParams } from 'react-router'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { PARAM } from '@App/navigation/param'

const ViewWorkPublicScene = observer(() => {
    const { publicViewWorkStore } = useContext(StoresContext)
    const params = useParams<typeof PARAM>()

    useEffect(() => {
        if (!publicViewWorkStore.viewWorkPublic) {
            const workId = params.workId
            if (workId) {
                publicViewWorkStore.getWorkCatalogById(workId).then()
            }
        }
        analyticsSendPage('view_work_public')
        return () => publicViewWorkStore.resetViewWorkPublic()
    }, [])

    return (
        <>
            <title>View Work</title>
            {publicViewWorkStore.viewWorkPublic && (
                <main className="view-work-public-scene">
                    <div className="global-container">
                        <PublicWorkHeader work={publicViewWorkStore.viewWorkPublic} />
                        <ViewWork viewWork={publicViewWorkStore.viewWorkPublic} showMatchedRecordings workType="work" />
                    </div>
                </main>
            )}
        </>
    )
})

export default ViewWorkPublicScene
